import UsersHA from './UsersHA';

export default UsersHA;
